<div class="row">
    <otb-inner-breadcrumb
        *otbShowInEnv="['default', 'justice', 'finance', 'sh', 'hmdj', 'bb-jm']"
    ></otb-inner-breadcrumb>
    <otb-progress-bar></otb-progress-bar>
</div>

@if (calendarShow) {
    <div class="row" [class.d-none]="calendarLoading">
        <div class="col-12">
            <h2
                [innerHTML]="
                    'dynamische_frontend_texte.datum_auswahl.html_content.ueberschrift' | translate | safeStyle
                "
            ></h2>
        </div>

        @if (showFormSwitcherTop && !isServiceOnly) {
            <div class="col-12 mb-5">
                <div class="changeform__container">
                    <a
                        (click)="switchToTimeFirst($event)"
                        href="#"
                        class="changeform has--before-arrow"
                        title="{{
                            'dynamische_frontend_texte.datum_auswahl.attribute_text.suche_fuer_bestimmte_zeit'
                                | translate
                        }}"
                        [innerHTML]="
                            'dynamische_frontend_texte.datum_auswahl.html_content.suche_fuer_bestimmte_zeit'
                                | translate
                                | safeStyle
                        "
                    >
                    </a>
                </div>
            </div>
        }
        <div class="col-12 col-md-6 mb-5">
            <div class="upper__container mb-5 mb-sm-2">
                <p
                    id="date-context"
                    [innerHTML]="
                        'dynamische_frontend_texte.datum_auswahl.html_content.label_kalendar' | translate | safeStyle
                    "
                ></p>
            </div>
            <div
                #calendarContainer
                class="mb-3"
                role="region"
                aria-labelledby="date-context"
                [class.colorblind-active]="colorLegendShow | async"
            >
                <input type="hidden" #datepicker />
            </div>
            @if (!showFormSwitcherTop && !isServiceOnly) {
                <div class="col-12 mb-5">
                    <div class="changeform__container">
                        <a
                            (click)="switchToTimeFirst($event)"
                            href="#"
                            class="changeform has--before-arrow"
                            title="{{
                                'dynamische_frontend_texte.datum_auswahl.attribute_text.suche_fuer_bestimmte_zeit'
                                    | translate
                            }}"
                            [innerHTML]="
                                'dynamische_frontend_texte.datum_auswahl.html_content.suche_fuer_bestimmte_zeit'
                                    | translate
                                    | safeStyle
                            "
                        >
                        </a>
                        <fa-icon class="fa" [icon]="faArrowCircleRight"></fa-icon>
                    </div>
                </div>
            }
            <otb-color-legend></otb-color-legend>
        </div>
        <div class="col-12 col-md-6">
            <!-- if application_settings service_only is false, show only regular process -->
            @if (!timesLoading) {
                @if (!isServiceOnly) {
                    <otb-time-pick-selection
                        [availableAgencies]="availableAgencyTimes"
                        [reservationLoading]="appointmentReservationLoading | async"
                        (timeSelect)="onTimeSelect($event)"
                    ></otb-time-pick-selection>
                } @else {
                    <otb-service-only-time-pick
                        [availableDetailedAgencies]="availableDetailedAgencyTimes"
                        (timeSelect)="onTimeSelectServiceOnly($event)"
                    ></otb-service-only-time-pick>
                    @if (appointmentReservationLoading | async) {
                        <div class="d-flex mt-3 align-items-center justify-content-center">
                            <div class="mx-3 d-inline">
                                <span>Ihr Termin wird reserviert...</span>
                            </div>
                            <div class="spinner-border" role="status" aria-atomic="true">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    }
                }
            } @else {
                <otb-loading-animation-dots
                    [text]="'dynamische_frontend_texte.lade_animation.zeiten'"
                ></otb-loading-animation-dots>
            }
            <!-- else show service only -->
        </div>
    </div>
} @else {
    <div class="row">
        <div class="col-12">
            <p
                class="info__header"
                [innerHTML]="
                    'dynamische_frontend_texte.datum_auswahl.html_content.ueberschrift_keine_termine'
                        | translate
                        | safeStyle
                "
            ></p>
            <p
                class="info__content"
                [innerHTML]="
                    'dynamische_frontend_texte.datum_auswahl.html_content.naechste_freie_termine'
                        | translate
                        | replaceDateTime: nextAppointmentAt
                        | async
                "
            ></p>
        </div>
    </div>
}
@if (calendarLoading) {
    <div class="row">
        <div class="col-12">
            <otb-loading-animation-dots
                [text]="'dynamische_frontend_texte.lade_animation.kalender'"
            ></otb-loading-animation-dots>
        </div>
    </div>
}

<div class="row">
    <div class="form-group d-flex justify-content-between flex-md-row flex-column mt-4 gap-2">
        <otb-back-button></otb-back-button>

        @if (!isServiceOnly && calendarShow) {
            <div
                class="d-flex flex-column flex-md-row align-items-md-center justify-content-md-end gap-3 order-md-2 order-1"
            >
                @if (appointmentReservationLoading | async) {
                    <div class="d-flex align-items-center" role="status" aria-atomic="true">
                        <span class="mx-3">Ihr Termin wird reserviert...</span>
                        <div class="spinner-border">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                }
                <button
                    type="button"
                    class="btn-success btn m-0 mb-3 mb-sm-0"
                    accesskey="w"
                    btnPrimaryColorDirective
                    [class.disabled]="!timePick?.timeSelected || !timePick?.submitBtnActive"
                    [attr.aria-disabled]="!timePick?.timeSelected || !timePick?.submitBtnActive ? 'true' : null"
                    (click)="timePick?.submit()"
                    [innerHTML]="'dynamische_frontend_texte.shared.button.next' | translate | safeStyle"
                ></button>
            </div>
        }
    </div>
</div>
